import React, { Component, createRef } from 'react';
import { string, node, bool } from 'prop-types';

export default class StickyTable extends Component {
  static propTypes = {
    children: node.isRequired,
    className: string,
    disabled: bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      error: false,
    };

    this.$tableContainer = createRef();
    this.$tableHead = null;
    this.isFixedHeader = false;
  }

  getTableHead = (table) => {
    return table.getElementsByTagName('th');
  };

  getHeader = () => {
    return document.getElementsByClassName('sidebar-main-header')[0];
  };

  // isFixedHeader = theme => theme === 3;

  handleScroll = () => {
    const { disabled } = this.props;
    if (!this.$tableHead || disabled) return;

    const scrollPosition = window.pageYOffset;
    const rect = this.$tableContainer.current.getBoundingClientRect();

    this.headerHeight = this.$header.scrollHeight;

    const offset = this.isFixedHeader ? this.headerHeight : 0;
    const startPoint = rect.top + scrollPosition - offset;
    const deltaY = scrollPosition - startPoint - 1; // -1 - hardcoded border width
    const translateY = deltaY > 0 ? deltaY : 0;

    Array.from(this.$tableHead).forEach(
      (th) => (th.style.transform = `translate3d(0, ${translateY}px, 0)`),
    );
  };

  componentDidMount() {
    const { theme } = this.props;

    this.$tableHead = this.getTableHead(this.$tableContainer.current);
    this.$header = this.getHeader();
    // this.isFixedHeader = this.isFixedHeader(theme);

    window.addEventListener('scroll', this.handleScroll, false);
    window.addEventListener('resize', this.handleScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false);
    window.removeEventListener('resize', this.handleScroll, false);
  }

  componentDidCatch() {
    this.setState((error) => ({ error: true }));
  }

  componentDidUpdate(prevProps) {
    const { disabled } = this.props;
    if (disabled && disabled !== prevProps.disabled) {
      Array.from(this.$tableHead).forEach((th) => (th.style.transform = `translate3d(0, 0, 0)`));
    }
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    return error ? children : <div ref={this.$tableContainer}>{children}</div>;
  }
}
